// dependencies
import { fromJS } from "immutable";
import { getMatchedRouteKeyValue } from "yarrr";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// components
import Spinner from "Components/Spinner/PageSpinner";

// config

// selectors
import { GenerateProcess } from "redux-process";

// styles
import css from "./ViewScheduledNotification.styl";

const ViewScheduledNotification = () => {
	const [data, setData] = useState(null);

	const dispatch = useDispatch();
	const notificationID = useSelector((state) => getMatchedRouteKeyValue(state, "notificationID", null));

	useEffect(() => {
		async function fetchData() {
			const response = await dispatch(GenerateProcess("fetch scheduled notification", { notificationID }));
			setData(response.response);
		}

		fetchData();
	}, []);

	if (!data) {
		return <Spinner />;
	}

	return (
		<div className={css.main}>
			<div className={css.content}>
				<div className={css.request}>
					<div>Request</div>
					<div className={css.jsonResponse}>{JSON.stringify(data.request, null, 4)}</div>
				</div>

				<div className={css.events}>
					<div>Events ({data.events.length})</div>
					<div className={css.jsonResponse}>{JSON.stringify(data.events, null, 4)}</div>
				</div>

				<div className={css.events}>
					<div>Created Notifications ({data.createdNotifications.length})</div>
					<div className={css.jsonResponse}>{JSON.stringify(data.createdNotifications, null, 4)}</div>
				</div>

				<div className={css.events}>
					<div>Cancelled Notifications ({data.cancelledNotifications.length})</div>
					<div className={css.jsonResponse}>{JSON.stringify(data.cancelledNotifications, null, 4)}</div>
				</div>
			</div>
		</div>
	);
};

export default ViewScheduledNotification;
